import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfConfiguracion } from '@/modules/Configuracion/interfaces'
import type { AxiosResponse } from 'axios'
export class ConfiguracionServicios extends BaseService<IConfConfiguracion> {
  constructor () {
    super({
      baseUrl: 'system/settings/'
    })
  }
  async save (
    data: IConfConfiguracion[]
  ): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http
      .post<boolean>(`/save-settings`, data)
      .catch(this.errorHandle)
  }
  async checkConfiguration (): Promise<AxiosResponse<IResponseApi<Record<string, boolean>>>> {
    return this.http
      .get<Record<string, boolean>>(`/checkConfiguration`)
      .catch(this.errorHandle)
  }
}
